import type { ArchiveRound } from '../archive/api';

/**
 * 这一期的十位公共数字。
 *
 * <p><b>`draw_digits` 可能是字符串也可能是数组</b>（`ArchiveRound` 的类型是
 * `string | number[]`）。直接 `String(...)` 会把数组变成 `"3,6,5,4,…"`——
 * 所以这个归一化必须走这个函数，不许在调用方各写一遍。
 */
export function drawDigits(round: ArchiveRound): string {
  if (Array.isArray(round.draw_digits)) return round.draw_digits.join('').replace(/\D/g, '');
  return String(round.draw_digits || '').replace(/\D/g, '');
}

/**
 * B1/B2/B3 三行。
 *
 * <p>取自 `eth_digits`，**不是**从哈希里现抓数字：后端已经把「末 10 个数字」
 * 这一步算好了，前端再抓一遍就是第二份实现，两边一旦不一致谁也发现不了。
 */
export function blockDigitRows(round: ArchiveRound): string[] {
  return (round.eth_digits || [])
    .map((row) => {
      if (Array.isArray(row)) return row.join('').replace(/\D/g, '');
      return String(row || '').replace(/\D/g, '');
    })
    .filter(Boolean)
    .slice(0, 3);
}

/** 这一期的关闭时刻，秒。区块卡用它算「开奖后第几秒出的块」。 */
export function roundCloseTimestamp(round: ArchiveRound): number {
  return Number(round.ends_at || round.cutoff_ts || round.starts_at || 0);
}

/**
 * 三行 B 逐列相加 → 十列和。行数不足 3 时返回空数组，调用方据此判断是展示
 * 真实的 B/Sum/D 表还是退回占位 D 行。
 *
 * <p>与 `RoundDigitsTable`、`DrawDetailContent` 的 `VerifyDerivationPanel`、
 * 数字卡的「说明 callout」共用同一份实现——三处都要判断/使用这批列和，
 * 各写一遍就是三份可能各自漂移的算法。
 */
export function columnSums(rows: string[]): number[] {
  if (rows.length < 3) return [];
  return Array.from({ length: 10 }, (_, index) => rows.slice(0, 3).reduce((sum, row) => {
    const digit = Number(row[index]);
    return sum + (Number.isFinite(digit) ? digit : 0);
  }, 0));
}
